import { createContext, useContext } from 'react';

export const ResourceUserDetailsContext = createContext();

export const useResourceUserDetailsContext = () =>
  useContext(ResourceUserDetailsContext);

export default ResourceUserDetailsContext;
